<style>
  .requiredLabel:after {
  content: "*";
  color: red;
  font-size: 20px;
}

.RedBorder {
border: 1px solid red;
}

.edit-link {
color: blue !important;
cursor: pointer; /* Add a pointer cursor to indicate it's clickable */
}

.delete-link {
color: red !important;
cursor: pointer; /* Add a pointer cursor to indicate it's clickable */
}
</style>
<div class="col-12">
  <div class="row">
    <div class="col-12">
      <p class="step_title">Step 3:</p>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 paddingFull">
      <div class="container_box">
        <div class="margin_button_20">
          @if (_selectedModel.labelName !='inventories') {
            <div class="wrap">
              <input type="radio" name="import-upsert-setting" [(ngModel)]="_importUpsertSetting"
                (ngModelChange)="_importUpsertSettingChanged('new')" value="new" id="Option1" kendoRadioButton />
                <label class="k-radio-label" for="Option1">
                  Import New - for importing new records.
                </label>
              </div>
            }
            @if (_selectedModel.labelName !='inventories') {
              <div class="wrap">
                <input type="radio" name="import-upsert-setting" [(ngModel)]="_importUpsertSetting"
                  (ngModelChange)="_importUpsertSettingChanged('update')" value="update" id="Option2" kendoRadioButton />
                  <label class="k-radio-label" for="Option2">
                    Update Existing - for updating existing records with new or
                    updated attributes.
                  </label>
                </div>
              }
              @if (_selectedModel.labelName =='stockItems') {
                <div class="wrap">
                  <input type="radio" name="import-upsert-setting" [(ngModel)]="_importUpsertSetting"
                    (ngModelChange)="_importUpsertSettingChanged('alternateStockItem')" value="alternateStockItem"
                    id="Option3" kendoRadioButton />
                    <label class="k-radio-label" for="Option3">
                      Add Alternate Stock #s - for adding additional Alternate Stock #s to an existing record.
                    </label>
                  </div>
                }
                @if (_selectedModel.labelName =='stockItems'&&  !_currentUser.isEnterprise) {
                  <div class="wrap">
                    <input type="radio" name="import-upsert-setting" [(ngModel)]="_importUpsertSetting"
                      (ngModelChange)="_importUpsertSettingChanged('locationMinMax')" value="locationMinMax" id="Option4"
                      kendoRadioButton />
                      <label class="k-radio-label" for="Option4">
                        Add Location Min/Max - for adding location min/max to existing records.
                      </label>
                    </div>
                  }
                  @if (_selectedModel.labelName =='inventories') {
                    <div class="wrap">
                      <input type="checkbox" name="import-upsert-setting" [(ngModel)]="_importUpsertSettingCheckBox"
                        (ngModelChange)="_importUpsertSettingCheckboxChanged(_importUpsertSettingCheckBox)"
                        value="treatAsReceiveTransaction" id="Option5" kendoRadioButton />
                        <label class="k-radio-label" for="Option5">
                          Treat this as a Receive transaction i.e. add to inventory and write to history.
                        </label>
                      </div>
                    }
                    @if (_selectedModel.labelName =='assets') {
                      <div class="wrap">
                        <input type="radio" name="import-upsert-setting" [(ngModel)]="_importUpsertSetting"
                          (ngModelChange)="_importUpsertSettingChanged('assignedAssets')" value="assignedAssets" id="Option6"
                          kendoRadioButton />
                          <label class="k-radio-label" for="Option6">
                            Assign Assets.
                          </label>
                        </div>
                      }
                    </div>

                    <div class="row">
                      <div class="col-6 col-sm-6 col-md-6 col-lg-6col-xl-5">
                        <div class="import-title-header">
                          Map the fields from your import file to the Barcloud NG fields.
                        </div>
                      </div>
                      <div class="col-6 col-sm-6 col-md-6 col-lg-6col-xl-5">
                        <div class="form-group">

                          <kendo-combobox [data]="ImportMapList" [suggest]="true" [valueField]="'id'" [textField]="'mapName'"
                            placeholder="Choose a saved  map" (valueChange)="_handleSavedMapChange($event)"
                            [(ngModel)]="ImportMapItem" [ngModelOptions]="{standalone: true}"
                            class="newFormControlWidth">
                          </kendo-combobox>
                        </div>

                      </div>
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-2"></div>
                    </div>
                    <div class="row">
                      <!-- <div class="col-6 col-sm-6 col-md-6 col-lg-6col-xl-5">
                      <div class="import-title-header">

                      </div>
                    </div> -->
                    <div class="col-8 col-sm-8 col-md-8 col-lg-6col-xl-7">
                      <div class="form-group">

                        <div style="margin-right:180px;" class="upsert-header-buttons">
                          <ul class="menuButtonsList">
                            <li (click)="openEditDeleteDialog()">
                              Manage Saved Maps
                            </li>
                          </ul>
                        </div>
                      </div>

                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-2"></div>
                  </div>
                  <kendo-grid [data]="_mapFieldsData" class="mapfiealdsGrid">
                    <kendo-grid-column field="barcloudField" title="Barcloud Fields" [hidden]="true" [headerStyle]="{'font-weight': 'bold'}">
                    </kendo-grid-column>

                    <kendo-grid-column field="barcloudMappedName" title="Barcloud NG Fields" [headerStyle]="{'font-weight': 'bold'}">
                      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                        <!-- *ngIf="(fundingSourceSettingEnabled && dataItem.barcloudMappedName == 'Funding Source ID') || (dataItem.barcloudMappedName != 'Funding Source ID')" -->
                        <div class="form-group">
                          <label [ngClass]="dataItem.required ? 'requiredLabel': ''"> {{dataItem.barcloudMappedName}}</label>
                        </div>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="importedField" title="Your Fields" [headerStyle]="{'font-weight': 'bold'}">
                      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                        <!-- *ngIf="(fundingSourceSettingEnabled && dataItem.barcloudMappedName == 'Funding Source ID') || (dataItem.barcloudMappedName != 'Funding Source ID')" -->
                        <kendo-combobox class="mapFieldsCombobox" #your_fields
                          [data]="_listExcelHeaders"
                          [placeholder]="'-- Select One --'"
                          [value]="dataItem.importedField"
                          [ngClass]="dataItem.required ? 'bordered ': ''"
                          (valueChange)="_importedFieldSelected($event, dataItem.barcloudLabel , rowIndex, false)">
                        </kendo-combobox>
                      </ng-template>
                    </kendo-grid-column>
                  </kendo-grid>
                </div>
              </div>
            </div>
          </div>

          @if (showEditDeleteMapDialog) {
            <kendo-window [width]="750" (close)="closeEditDeleteDialog()"
              (keydown.enter)="$event.preventDefault()" style="z-index:100005">
              <div class="col-12 form-group">
                <div style="margin-top: 10px;  margin-right: 5px;">
                  Saved Maps
                </div>
                <div class="row">
                  <div class="form-group">
                    <div style="margin-right:180px;" class="upsert-header-buttons">
                      <!-- <ul class="menuButtonsList">
                      <li (click)="editSavedMap()">
                        Edit
                      </li>
                      <li (click)="deleteSavedMap()">
                        Delete
                      </li>
                      <span style="font-size: 13px;">Test</span>
                    </ul> -->
                    <ul class="menuButtonsList">
                      <kendo-grid [data]="ImportMapList">
                        <kendo-grid-column title="Edit">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            <a (click)="editMap(dataItem)" class="edit-link">Edit</a>
                          </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="Delete">
                          <ng-template kendoGridCellTemplate let-dataItem>
                            <a (click)="deleteMap(dataItem) " class="delete-link">Delete</a>
                          </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="mapName"></kendo-grid-column>
                      </kendo-grid>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </kendo-window>
        }
